import { createContext } from 'react'

import type { StoreReadOnly } from '@subaio/utils'

export type UserManager<T = any> = StoreReadOnly<T> & {
	hasRole: (role: string) => boolean
}

export const context = createContext<UserManager | undefined>(undefined)
